// extracted by mini-css-extract-plugin
module.exports = {"subscribers":"subscribers-get_subscribers__VmKy3","icon":"subscribers-get_icon__k31ct"};